import { useState } from "react";
import Container from "../../components/container/Container";
import { signInWithPopup, signInWithEmailAndPassword } from "firebase/auth";
import { auth, provider } from "../../database/firebase";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";

const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const signUpWithEmailAndPassword = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await signInWithEmailAndPassword(auth, email, password);
      setEmail("");
      setPassword("");
      setLoading(false);
    } catch (error) {
      alert(error.message);
    }
  };

  const signUpwithGoogle = async () => {
    try {
      setGoogleLoading(true);
      await signInWithPopup(auth, provider);
      setGoogleLoading(false);
    } catch (error) {
      alert(error.message);
      setGoogleLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Container>
        <div className="py-3 px-3 lg:px-0">
          <Link to="/">
            <img
              src="/images/LogoSec.png"
              alt="Logo"
              className="cursor-pointer h-10"
            />
          </Link>
        </div>
        <div className="lg:grid lg:grid-cols-2 lg:gap-10 lg:items-center">
          <div className="flex flex-col space-y-8 px-3 lg:px-20 py-3 ">
            <div className="flex justify-center lg:justify-end">
              <h1 className="font-bold text-3xl text-indigo-500 font-serif">
                Sign In
              </h1>
            </div>
            <div className="space-y-3 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-5">
              <div
                onClick={signUpwithGoogle}
                className="flex cursor-pointer items-center border border-indigo-400 bg-indigo-500"
              >
                <div className="bg-white px-3 py-2">
                  <img src="/images/google.png" alt="google" className="h-6" />
                </div>
                <div className="ml-10 lg:ml-3">
                  <p className="font-semibold font-serif text-white">
                    {googleLoading ? (
                      <ClipLoader
                        color="white"
                        loading={googleLoading}
                        size={25}
                      />
                    ) : (
                      "Signin with Google"
                    )}
                  </p>
                </div>
              </div>
              <div className="flex items-center border cursor-pointer border-indigo-400 bg-indigo-500">
                <div className="bg-white px-3 py-2">
                  <img src="/images/github.png" alt="google" className="h-6" />
                </div>
                <div className="ml-10 lg:ml-3">
                  <p className="font-semibold font-serif text-white">
                    Signin with Github
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <p className="font-bold text-lg">or</p>
            </div>
            <div className="">
              <form
                className="flex flex-col space-y-5"
                onSubmit={signUpWithEmailAndPassword}
              >
                <div className="flex flex-col space-y-5">
                  <input
                    className="signup__input"
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                    className="signup__input"
                    type="password"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="">
                  <button
                    type="submit"
                    className="bg-indigo-600 py-2 w-full text-white font-serif font-semibold border-none focus:outline-none"
                  >
                    {loading ? (
                      <ClipLoader color="white" loading={loading} size={25} />
                    ) : (
                      "Sign in"
                    )}
                  </button>
                </div>
              </form>
            </div>
            <div className="text-center">
              <p className="font-mono">
                Create new account ?{" "}
                <Link
                  to="/sign-up"
                  className="text-blue-500 hover:underline cursor-pointer"
                >
                  Sign up
                </Link>{" "}
              </p>
            </div>
          </div>
          <div className="hidden lg:inline-grid lg:place-items-end px-5 py-5">
            <img src="/images/Signin.svg" alt="" />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Signin;
